var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CardContext } from '../card/card';
import CardContent from '../card-content/card-content';
const CardFlipContent = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const context = React.useContext(CardContext);
    React.useEffect(() => {
        if (children) {
            context.setHasFlipContent(true);
        }
    }, [children, context]);
    const BEM = () => {
        const classArray = ['card__flip-content'];
        if (props.className) {
            classArray.push(props.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement(CardContent, Object.assign({}, rest, { className: BEM() }), children));
};
export { CardFlipContent as default, };
